import { cx } from '@emotion/css';
import type { FC } from 'react';

import { footerSocialClassName, footerSocialWrapperClassName } from '../Footer.constants';
import {
  footerSocialContainerCss,
  footerSocialContainerOffsetCss,
  footerSocialCss,
  footerSocialIconsWrapperCss,
  wrapperCss,
} from './styles';
import type { FooterSocialProps } from './types';

export const FooterSocial: FC<FooterSocialProps> = ({ title, hasSideNav, children }) => {
  return (
    <section data-testid="footer-social" className={cx(footerSocialWrapperClassName, wrapperCss)}>
      <div
        className={cx(footerSocialClassName, footerSocialContainerCss, {
          [footerSocialContainerOffsetCss]: hasSideNav,
        })}
      >
        <div className={footerSocialCss}>
          {title && <h5>{title}</h5>}
          <div className={footerSocialIconsWrapperCss}>{children}</div>
        </div>
      </div>
    </section>
  );
};
